import { Controller } from "@hotwired/stimulus"
import { TRACKING_CONSENT_ACCEPTED_EVENT, track, trackingAllowed } from "../lib/analytics"

// Fires feature_view once when the feature show page connects. Read the
// feature id from a data value so the controller is reusable.
export default class extends Controller {
  static values = { featureId: String }

  connect() {
    this.onTrackingConsentAccepted = this.onTrackingConsentAccepted.bind(this)
    document.addEventListener(TRACKING_CONSENT_ACCEPTED_EVENT, this.onTrackingConsentAccepted)
    if (trackingAllowed()) this.fire()
  }

  disconnect() {
    document.removeEventListener(TRACKING_CONSENT_ACCEPTED_EVENT, this.onTrackingConsentAccepted)
  }

  onTrackingConsentAccepted() {
    this.fire()
  }

  fire() {
    if (this._fired) return
    this._fired = true
    if (!this.hasFeatureIdValue || !this.featureIdValue) return
    track("feature_view", { feature_id: this.featureIdValue })
  }
}
